import React from 'react'
import MatrimonyHeader from '../components/MatrimonyHeader'
import MatriMyProfileHero from "../components/MatriMyProfileHero"
import EditMyProfile from "../components/EditMyProfile"
import Footer from '../components/Footer'

function MatrimonyEditMyProfile() {
  return (
    <div>
        <MatrimonyHeader />
        <MatriMyProfileHero />
        <EditMyProfile />
        <Footer />
    </div>
  )
}

export default MatrimonyEditMyProfile